<template>
  <div id="trip">
    <div id="myMap" :class="{ blurry : !userGesture }"></div>
  </div>
</template>

<script>
// import { LMap, LImageOverlay, CRS } from "leaflet";
import L from "leaflet";
import EventBus from "../Event";
import "leaflet/dist/leaflet.css";

export default {
  name: "Trip",
  props: ["userGesture", "isMobile"],
  components: {
    // LMap,
    // LImageOverlay
  },
  data() {
    return {
      url: require("../assets/tim_f5.gif"),
      coverart: require("../assets/FRONT-01.png"),
      zoom: 5,
      bounds: [
        [0, 0],
        [120, 216]
      ],
      myMap: null
    };
  },
  mounted() {
    let VueThis = this;

    VueThis.myMap = L.map("myMap", {
      crs: L.CRS.Simple,
      zoomControl: false,
      attributionControl: false,
      maxBounds: [
        [0, 0],
        [120, 216]
      ]
    }).setView([59, 110], 5);

    L.imageOverlay(VueThis.url, VueThis.bounds).addTo(VueThis.myMap);

    let albumCover = L.icon({
      iconUrl: VueThis.coverart,
      // shadowUrl: VueThis.shadow,
      iconSize: [550, 550], // size of the icon
      shadowSize: [600, 600], // size of the shadow
      iconAnchor: [275, 275], // point of the icon which will correspond to marker's location
      shadowAnchor: [275, 275], // the same for the shadow
      popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
    });
    let bandcampMarker = L.marker([59, 110], { icon: albumCover });
    bandcampMarker.addTo(VueThis.myMap);
    bandcampMarker.on("click", function() {
      window.open("https://traumgarten.bandcamp.com/album/flowers-that-bloom-at-midnight");
    });

    VueThis.myMap.touchZoom.disable();
    VueThis.myMap.doubleClickZoom.disable();
    VueThis.myMap.scrollWheelZoom.disable();
    VueThis.myMap.dragging.disable();
    VueThis.myMap.boxZoom.disable();
    VueThis.myMap.keyboard.disable();

    EventBus.$on("changeLocation", function(LatLong) {
      VueThis.myMap.panTo([LatLong[1], LatLong[0]], {
        animate: true,
        duration: 4
      });
    });
  },
  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    }
  }
};
</script>

<style lang='scss'>
video {
  z-index: 1000;
  opacity: 0.8;
}

#trip {
  position: fixed;
  background-color: black;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  pointer-events: none;
  touch-action: none;
}

#myMap {
  position: absolute;
  background-color: black;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  pointer-events: none;
  touch-action: none;
}

.blurry {
  // filter: blur(2px);
}
</style>